import { jsx as _jsx } from "react/jsx-runtime";
const variantStyles = {
    'on-track': { color: '#1a7f4b', bg: '#1a7f4b1a' },
    'watch': { color: '#d97706', bg: '#d977061a' },
    'concern': { color: '#dc2626', bg: '#dc26261a' },
    'pending': { color: '#0453cd', bg: '#0453cd1a' },
    'inactive': { color: '#6b7280', bg: '#6b72801a' },
    'completed': { color: '#1a7f4b', bg: '#d1fae5' },
    'in-progress': { color: '#0453cd', bg: '#d6e4ff' },
    'improving': { color: '#ff4d00', bg: '#ffe5d9' },
};
export function StatusChip({ variant, label, className = '' }) {
    const { color, bg } = variantStyles[variant];
    return (_jsx("span", { className: `inline-flex items-center rounded-full px-3 py-1.5 text-[13px] font-medium leading-none whitespace-nowrap ${className}`, style: { color, backgroundColor: bg }, children: label }));
}
